/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Save_PreviewInputs */

const vi_einvoice_buyer_save_preview = /** @type {(inputs: Einvoice_Buyer_Save_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu và xem lại nháp`)
};

/**

* @param {Einvoice_Buyer_Save_PreviewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_save_preview = /** @type {((inputs?: Einvoice_Buyer_Save_PreviewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Save_PreviewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_save_preview(inputs)
});